var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"btn btn-primary px-5 py-3 fw-semibold h5 font-weight-bold z-2 my-3 my-md-4 primary-button",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }